/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { InvestmentStatusValues } from '../types/utils';

export class InvestmentStatusChangeLogEntry {
	createdAt?: Date

	data?: string

	status: InvestmentStatusValues = InvestmentStatusValues.AWAITING_PAYMENT
}